import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PayrollItemsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/salary-and-wages/_layout/payroll-items/')({
  validateSearch: zodValidator(PayrollItemsSearchSchema)
});